import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

// Register the PWA service worker (registerType: 'autoUpdate' + skipWaiting +
// clientsClaim). HTML is served network-first (see vite.config.ts
// workbox.runtimeCaching), so a single refresh after any deployment always loads
// the newest build; new versions surface through the existing update banner
// (isats:update-available → "Refresh Now").
registerSW({ immediate: true });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
